import { AfterContentInit, Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { BehaviorSubject } from 'rxjs';
import { User } from '../../../models/user';
import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-vj-profile-nav-bar',
  templateUrl: './vj-profile-nav-bar.component.html',
  styleUrls: ['./vj-profile-nav-bar.component.css'],
})
export class VjProfileNavBarComponent implements OnInit {
  searchVisible: boolean = false;
  quickViewVisible: boolean = false;
  isFolded: boolean;
  isExpand: boolean;
  public UserData: any ={};
  public UserStatus: boolean;
  private userSubject: BehaviorSubject<User>;
  profile: any;

  constructor(
    public router: Router,
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    public jwtHelper: JwtHelperService,
    public msalService: MsalService
  ) {}

  ngOnInit(): void {
    this.getLoginStatus();
    this.getuserValue();
     
    //  if(!localStorage.getItem('user')){
    //   this.authenticationService.getProfile();
    //   this.UserData = localStorage.getItem('user');
    //  }else{
    //   this.UserData =localStorage.getItem('user');
      
    //  }

    //  this.authenticationService.user.subscribe(data=>{
    //   this.UserData = data;
    //  });


  }


  public getuserValue() {
    let userInfo = JSON.parse(localStorage.getItem('user'));
    if (!userInfo) {
      this.http
        .get('https://graph.microsoft.com/v1.0/me')
        .subscribe((profile) => {
          localStorage.setItem('user', JSON.stringify(profile));
          this.UserData = profile;

          this.authenticationService.user = JSON.parse(
            localStorage.getItem('user')
          );
        });
    } else {
      this.UserData = JSON.parse(localStorage.getItem('user'));
    }
  }
 




  getLoginStatus() {
    this.UserStatus = this.authenticationService.loginDisplay;
  }

  login() {
    this.authenticationService.loginRedirect();
  }

  logout() {
    localStorage.clear();
    this.authenticationService.logout();
  }
}
